import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import { Toolbar, LinearProgress, Container } from '@material-ui/core'
import ReaderAppbar from './reader-appbar.component'
import DigiIebookReaderFrame from './digiiebook-reader-frame.component'
import { useDigiIebookState } from './use-digiiebook-state.hook'
import { useReaderContext } from './context/reader-context'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
}))

function ReaderDigiIebook() {
  const classes = useStyles()

  const {
    iRef,
    digiiebook: { url },
    info: { title },
  } = useReaderContext()

  const {
    ui: { SHOW_ASSIGNMENT_CREATE_BUTTON },
    actions: { handleLoad },
    hasLoaded,
  } = useDigiIebookState()

  return (
    <div className={classes.root}>
      <ReaderAppbar
        hasDrawer={false}
        hideControls={true}
        title={title}
        enableCreateAssignment={SHOW_ASSIGNMENT_CREATE_BUTTON}
      />
      <Container maxWidth="xl" disableGutters>
        <Toolbar />
        {!hasLoaded ? <LinearProgress style={{ width: '1920px' }} /> : null}
        <DigiIebookReaderFrame
          ref={iRef}
          variant={'digiiebook'}
          loaded={hasLoaded}
          frameSrc={url}
          onLoad={handleLoad}
        />
      </Container>
    </div>
  )
}

ReaderDigiIebook.propTypes = {
  title: PropTypes.string,
  url: PropTypes.string,
  availableActivities: PropTypes.array,
  currentActivity: PropTypes.any,
  currentIndex: PropTypes.any,
  setActivity: PropTypes.func,
  setIndex: PropTypes.func,
}

export default ReaderDigiIebook
